import { useContext } from "react";
import { useMixPanelForTracking } from "../../../../utils/TrackMixPanel";
import { UserApiContext } from "../../../UserDetailsContext/UserDetailsContext";
import { MyCompanyProfileContext } from "../../../../MyCompanyProfileContext";
import PopupModal from "../../../Shared/PopupModal/PopupModal";
import ViewConsignmentDetails from "./ConsignmentPopup";

const ShipmentOverview = ({ err, data, loading, apiCall, carrier }) => {
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const { TrackMixPanel } = useMixPanelForTracking(
    userDetails,
    companySettingData
  );

  const actual_route =
    data?.status?.length >= 4
      ? "0 km"
      : data?.truckLocs && data?.truckLocs?.length < 1
        ? data?.feasibleRoute?.feasible_gdistance
        : data?.actualRoute?.remaining_distance;

  return (
    <div className="col-12 col-xl-3">
      <div
        className="card shadow-lg border-0"
        style={{
          borderRadius: "0.75rem",
          overflow: "hidden",
          transition: "transform 0.2s ease, box-shadow 0.2s ease",
        }}
      >
        {/* HEADER */}
        <div
          className="card-header d-flex align-items-center justify-content-between text-white"
          style={{
            background: "linear-gradient(135deg, #00b4d8)",
            borderBottom: "none",
            // padding: "0.75rem 1.25rem",
          }}
        >
          <h3 className="h5 mb-0 font-weight-bold d-flex align-items-center">
            <i className="fa fa-truck mr-2" aria-hidden="true"></i> Shipment
            Overview
          </h3>

          <button
            // disabled={err}
            onClick={() => apiCall()}
            className="btn btn-sm btn-light text-black border-0"
            style={{
              backgroundColor: "rgba(225, 227, 235, 0.56)",
              borderRadius: "0.5rem",
            }}
            title="Refresh"
          >
            <i className={`fa fa-refresh ${loading ? "fa-spin" : ""}`}></i>
          </button>
        </div>

        {/* BODY */}
        <div className="card-body">
          {/* ROUTE */}
          <div className="mb-4">
            <div className="text-secondary text-uppercase small font-weight-semibold mb-1">
              Route
            </div>
            <div
              style={{
                fontSize: data?.route?.length <= 63 ? "20px" : "16.999px",
                fontWeight: "500",
              }}
              title={data?.route}
            >
              {data?.route?.length > 78
                ? data?.route?.substring(0, 75) + "..."
                : data?.route}
            </div>
          </div>

          {/* distance + eta */}
          <div className="mb-4">
            <div className="d-flex flex-column align-items-start w-100">
              {/* Status & Date Row */}
              <div
                className="w-100 d-flex align-items-center justify-content-between mb-3"
                style={{
                  borderBottom: "1px dashed rgba(0,0,0,0.1)",
                  paddingBottom: "0.75rem",
                }}
              >
                <div>
                  <div className="text-secondary text-uppercase small font-weight-semibold mb-1">
                    Current Status
                  </div>
                  <div
                    className="text-capitalize"
                    style={{
                      fontSize: "1.2rem",
                      fontWeight: "700",
                      color: "#00b4d8",
                    }}
                  >
                    {data?.currentStatus || "--"}
                  </div>
                </div>
                <div>
                  <div className="text-secondary text-uppercase small font-weight-semibold mb-1 text-right">
                    Date of Placement
                  </div>
                  <div
                    style={{
                      fontSize: "1rem",
                      fontWeight: "600",
                    }}
                  >
                    {data?.dateOfPlacement || "--"}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {carrier?.trackingLink && carrier?.trackingLink !== "" && (
            <div className="mt-5">
              <button
                disabled={err}
                type="button"
                className="btn btn-outline-primary d-flex align-items-center justify-content-center w-100 px-4 py-2 text-primary border border-primary border-opacity-50 rounded"
                style={{
                  backgroundColor: "transparent",
                  transition: "background-color 0.2s ease",
                }}
                onClick={() => {
                  TrackMixPanel({
                    Definition: "user clicked on share tracking link.",
                    ModuleName: "lorri vehicle tracking",
                    ScreenName: "indent request - track and trace",
                    Data: {
                      Link: window.location.href,
                      Route: data?.route,
                      Carrier: carrier?.name,
                    },
                  });
                  window.open(carrier?.trackingLink, "_blank");
                }}
              >
                {" "}
                <i class="fa fa-external-link mr-2" /> Fetch GPS Data from LSP{" "}
              </button>
            </div>
          )}
        </div>
      </div>

      <div
        className="card shadow-lg border-0 mt-4"
        style={{
          borderRadius: "0.75rem",
          overflow: "hidden",
          transition: "transform 0.2s ease, box-shadow 0.2s ease",
        }}
      >
        <div
          className="card-header d-flex justify-content-between align-items-center text-white"
          style={{
            background: "linear-gradient(135deg, #00b4d8)",
            borderBottom: "none",
            // padding: "0.75rem 1.25rem",
          }}
        >
          <h3 className="h5 mb-0 font-weight-bold d-flex align-items-center">
            <i className="mr-2 fas fa-truck"></i>Vehicle Details
          </h3>
        </div>

        <div className="card-body">
          {/* Carrier + Truck Type */}
          <div className="row mb-3">
            <div className="col">
              <div className="text-muted small text-uppercase font-weight-semibold">
                Carrier
              </div>
              <div className="font-weight-bold text-dark h5 mb-0">
                {carrier?.name || "--"}
              </div>
            </div>
            <div className="col">
              <div className="text-muted small text-uppercase font-weight-semibold">
                Truck Type
              </div>
              <div className="font-weight-bold text-dark h5 mb-0">
                {carrier?.truckType || "--"}
              </div>
            </div>
          </div>

          <div
            style={{
              borderBottom: "1px dashed #dee2e6",
              margin: "0.75rem 0",
            }}
          ></div>

          <ul className="list-unstyled mb-0 mt-3">
            {carrier.driverName && (
              <li className="mb-2">
                <i className="text-primary"></i>
                <strong>Driver:</strong> {carrier.driverName}
              </li>
            )}
            {carrier.phone && (
              <li className="mb-2">
                <i className="text-success"></i>
                <strong>Contact:</strong> {carrier.phone}
              </li>
            )}
            <li className="d-flex align-content-center justify-content-between">
              {carrier.vehicleNumber && (
                <li>
                  <i className="text-warning"></i>
                  <strong>Vehicle No:</strong> {carrier.vehicleNumber}
                </li>
              )}
            </li>
            <li className="d-flex align-content-center my-3 justify-content-between">
              <PopupModal
                size="xl"
                title="View Consignment Details"
                buttonTitle="View Consignment Details"
                buttonLabel={
                  <span
                    style={{
                      // fontSize: "12px",
                      color: "#0dcaf0",
                      textDecoration: "underline",
                      cursor: "pointer",
                      lineHeight: "14px",
                    }}
                  >
                    <i className="fas fa-info-circle mr-2"></i>
                    View Consignment Details
                  </span>
                }
                buttonClass="btn btn-link p-0 m-0 text-info text-decoration-none"
                content={
                  <ViewConsignmentDetails indentDetails={data} data={data?.indentConsignment} />
                }
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ShipmentOverview;
